// Click & Collect Module
var State = /** @class */ (function () {
    function State() {
        this.gbpAmount = 1.00;
        this.exchangeAmount = "0";
    }
    return State;
}());
var ClickCollectHandler = /** @class */ (function () {
    function ClickCollectHandler(props) {
        this.defaultNumber = 1.00;
        this.state = new State();
        this.clickCollectPanel = props.clickCollectPanel;
        this.initializeElements();
        this.buyBackCharge = this.buyBackContainer ? parseFloat(this.buyBackContainer.dataset.buyBackCharge) : 0;
        this.setState();
        this.setInitialValues();
        this.setupEventListeners();
    }
    ClickCollectHandler.prototype.initializeElements = function () {
        this.currencyDropdown = this.getElement(ClickCollectHandler.SELECTORS.currencyDropdown, HTMLSelectElement);
        this.gbpInput = this.getElement(ClickCollectHandler.SELECTORS.gbpInput, HTMLInputElement);
        this.exchangeCurrency = this.getElement(ClickCollectHandler.SELECTORS.exchangeCurrency, HTMLElement);
        this.exchangeValInput = this.getElement(ClickCollectHandler.SELECTORS.exchangeValInput, HTMLInputElement);
        this.todayRate = this.getElement(ClickCollectHandler.SELECTORS.todayRate, HTMLElement);
        this.todayCode = this.getElement(ClickCollectHandler.SELECTORS.todayCode, HTMLElement);
        this.buyBackCheckbox = this.getElement(ClickCollectHandler.SELECTORS.buyBackCheckbox, HTMLInputElement);
        this.buyBackContainer = this.getElement(ClickCollectHandler.SELECTORS.buyBackContainer, HTMLElement);
        this.totalQuote = this.getElement(ClickCollectHandler.SELECTORS.totalQuote, HTMLElement);
        this.currencyQuote = this.getElement(ClickCollectHandler.SELECTORS.currencyQuote, HTMLElement);
        this.buyBackQuote = this.getElement(ClickCollectHandler.SELECTORS.buyBackQuote, HTMLElement);
        this.exchangeRateHiddenInput = this.getElement(ClickCollectHandler.SELECTORS.exchangeRateHiddenInput, HTMLInputElement);
        this.totalQuoteHiddenInput = this.getElement(ClickCollectHandler.SELECTORS.totalQuoteHiddenInput, HTMLInputElement);
    };
    ClickCollectHandler.prototype.setState = function () {
        this.state = {
            exchangeAmount: this.exchangeValInput.value,
            gbpAmount: parseFloat(this.gbpInput.value)
        };
        this.updateQuoteValues();
    };
    ClickCollectHandler.prototype.getElement = function (selector, type) {
        var element = this.clickCollectPanel.querySelector(selector);
        if (!element) {
            this.handleError(new Error("Element with selector \"".concat(selector, "\" not found.")));
            return null; // return a dummy element to satisfy TypeScript
        }
        return element;
    };
    ClickCollectHandler.prototype.handleError = function (error) {
        console.error(error);
        // Display a user-friendly message or take other appropriate actions
    };
    ClickCollectHandler.prototype.setInitialCurrencyValues = function () {
        var selectedOption = this.currencyDropdown.selectedOptions.length > 0
            ? this.currencyDropdown.selectedOptions[0]
            : this.currencyDropdown.options[0];
        if (selectedOption) {
            this.updateCurrencyUI(selectedOption);
        }
    };
    ClickCollectHandler.prototype.updateCurrencyUI = function (option) {
        var currencyCode = option.dataset['currencyCode'] || '';
        var rate = option.dataset['rate'] || '';
        var multiple = option.dataset['multiple'] || '';
        this.exchangeCurrency.innerHTML = currencyCode;
        this.todayRate.innerHTML = rate;
        this.todayRate.dataset['multiple'] = multiple;
        this.todayCode.innerHTML = currencyCode;
        this.exchangeRateHiddenInput.value = rate;
        this.state.exchangeAmount = this.exchangeValInput.value;
    };
    ClickCollectHandler.prototype.setInitialValues = function () {
        this.setInitialCurrencyValues();
        // Set initial state of buy back UI
        if (this.buyBackCheckbox.checked) {
            this.buyBackContainer.classList.remove('hidden');
        }
        else {
            this.buyBackContainer.classList.add('hidden');
        }
        this.updateQuoteValues();
    };
    ClickCollectHandler.prototype.setupEventListeners = function () {
        this.currencyDropdown.addEventListener('change', this.onCurrencyDropdownChange.bind(this));
        this.gbpInput.addEventListener('change', this.onGbpInputChange.bind(this));
        this.buyBackCheckbox.addEventListener('change', this.onBuyBackCheckboxChange.bind(this));
    };
    ClickCollectHandler.prototype.onCurrencyDropdownChange = function () {
        var _a;
        var selectedOption = (_a = this.currencyDropdown) === null || _a === void 0 ? void 0 : _a.selectedOptions[0];
        if (!selectedOption) {
            return; // Early exit if no option is selected
        }
        this.updateCurrencyDetails(selectedOption);
        this.updateExchangeValues();
        this.updateQuoteValues();
    };
    ClickCollectHandler.prototype.updateCurrencyDetails = function (option) {
        var currencyCode = option.dataset['currencyCode'] || '';
        var rate = option.dataset['rate'] || '';
        var multiple = option.dataset['multiple'] || '';
        if (this.exchangeCurrency)
            this.exchangeCurrency.innerHTML = currencyCode;
        if (this.todayRate) {
            this.todayRate.innerHTML = rate;
            this.todayRate.dataset['multiple'] = multiple;
        }
        if (this.todayCode)
            this.todayCode.innerHTML = currencyCode;
        if (this.exchangeRateHiddenInput)
            this.exchangeRateHiddenInput.value = rate;
        if (this.exchangeValInput)
            this.exchangeValInput.value = rate;
    };
    ClickCollectHandler.prototype.updateExchangeValues = function () {
        this.state.gbpAmount = this.defaultNumber;
        if (this.gbpInput)
            this.gbpInput.value = this.state.gbpAmount.toFixed(2);
    };
    /**
     * Handles changes to the GBP input.
     */
    ClickCollectHandler.prototype.onGbpInputChange = function () {
        this.validateGbpInput();
        this.calculateExchangeValue();
        this.updateGbpInputUI();
    };
    ClickCollectHandler.prototype.validateGbpInput = function () {
        var gbpValue = parseFloat(this.gbpInput.value);
        this.state.gbpAmount = isNaN(gbpValue) || gbpValue <= 0 ? this.defaultNumber : gbpValue;
    };
    ClickCollectHandler.prototype.calculateExchangeValue = function () {
        var exchangeRate = parseFloat(this.todayRate.innerHTML);
        var multipleVal = parseFloat(this.todayRate.dataset['multiple']);
        var exchangeVal = this.state.gbpAmount * exchangeRate;
        var remainder = exchangeVal % multipleVal;
        if (remainder > 0) {
            exchangeVal += (multipleVal - remainder);
            this.state.gbpAmount = Math.floor((exchangeVal / exchangeRate) * 100) / 100;
            this.gbpInput.value = String(this.state.gbpAmount.toFixed(2));
        }
        this.state.exchangeAmount = String(exchangeVal.toFixed(2));
        this.updateQuoteValues();
    };
    ClickCollectHandler.prototype.updateGbpInputUI = function () {
        this.gbpInput.value = this.state.gbpAmount.toFixed(2);
        this.exchangeValInput.value = this.state.exchangeAmount;
        // ... additional UI updates
    };
    ClickCollectHandler.prototype.onBuyBackCheckboxChange = function () {
        if (this.buyBackCheckbox.checked) {
            this.buyBackContainer.classList.remove('hidden');
        }
        else {
            this.buyBackContainer.classList.add('hidden');
        }
        this.updateQuoteValues();
    };
    ClickCollectHandler.prototype.updateQuoteValues = function () {
        var activeBuyBackCharge = this.buyBackCheckbox.checked ? this.buyBackCharge : 0;
        var totalQuoteVal = this.state.gbpAmount + activeBuyBackCharge;
        this.totalQuote.innerHTML = "\u00A3".concat(String(totalQuoteVal.toFixed(2)));
        this.currencyQuote.innerHTML = "\u00A3".concat(String(this.state.gbpAmount.toFixed(2)));
        this.buyBackQuote.innerHTML = "\u00A3".concat(String(this.buyBackCharge.toFixed(2)));
        this.totalQuoteHiddenInput.value = String(totalQuoteVal.toFixed(2));
    };
    ClickCollectHandler.SELECTORS = {
        currencyDropdown: '.js-currency-dropdown',
        gbpInput: '.js-gbp-input',
        exchangeCurrency: '.js-exchange-currency',
        exchangeValInput: '.js-exchange-val',
        todayRate: '.js-today-rate',
        todayCode: '.js-today-code',
        buyBackCheckbox: '.js-buyback-checkbox',
        buyBackContainer: '.js-buyback-container',
        totalQuote: '.js-total-quote',
        currencyQuote: '.js-currency-quote',
        buyBackQuote: '.js-buyback-quote',
        exchangeRateHiddenInput: '#Form_ExchangeRate',
        totalQuoteHiddenInput: '#Form_TotalQuote'
    };
    return ClickCollectHandler;
}());
export { ClickCollectHandler };
export default ClickCollectHandler;
